/**
 * UI Utilities - Static access to UI components
 * 
 * Provides static methods for common UI operations
 * Re-exports fixed Modal and Toast components
 */

import { ModalService } from '../ui-kit/ModalService.jsx';
import { confirmOverlay } from './Overlay.js';
import ToastComponent from '../components/Toast.js';

/**
 * Static Toast utility - delegates to fixed Toast component
 */
export const Toast = {
  show: (message, type = 'info') => {
    return ToastComponent.show(message, type);
  },
  
  success: (message) => {
    return ToastComponent.success(message);
  },
  
  error: (message) => {
    return ToastComponent.error(message);
  },
  
  warning: (message) => {
    return ToastComponent.warning(message);
  },
  
  info: (message) => {
    return ToastComponent.info(message);
  },
  
  clear: () => {
    return ToastComponent.clear();
  }
};

/**
 * Static Modal utility - delegates to fixed Modal component
 */
let _lastToken = null;
export const Modal = {
  show: (title, content, buttons = [], options = {}) => {
    const actions = buttons.map(btn => ({
      text: btn.text || btn.label,
      class: btn.class || btn.className || 'uk-btn uk-btn-secondary',
      action: typeof btn.action === 'function' ? btn.action : (btn.handler || (() => {}))
    }));
    const close = ModalService.open({ title, content, actions });
    _lastToken = close;
    return close;
  },
  hide: () => {
    try { ModalService.closeTop(); } catch (_) {}
    _lastToken = null;
  },
  confirm: (title, message, onConfirm, onCancel = null, options = {}) => {
    return confirmOverlay(title, message, onConfirm, onCancel);
  },
  info: (title, content) => {
    const close = ModalService.open({
      title,
      content,
      actions: [{ text: 'OK', class: 'uk-btn uk-btn-primary', action: () => Modal.hide() }]
    });
    _lastToken = close;
    return close;
  }
};

// Export as default for convenience
export default { Toast, Modal };

// Also make available globally for broader compatibility
if (typeof window !== 'undefined') {
  // Only set if not already set by the component files
  if (!window.Modal) {
    window.Modal = Modal;
  }
  if (!window.Toast) {
    window.Toast = Toast;
  }
}
